import { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  Grid,
  Card,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import { Helmet } from 'react-helmet-async';
import img1 from './Asset/1.webp';
import img2 from './Asset/2.webp';
import img3 from './Asset/3.webp';
import img4 from './Asset/4.webp';
import mobile1 from './Asset/4cars-home-mobile.webp';
import mobile2 from './Asset/Atto3-Mobile.webp';
import mobile3 from './Asset/Home-Banner-Dolphin_3-Mobile.webp';
import atto from './Asset/byd-atto3.webp';
import dolphin from './Asset/byd-dolphin.webp';
import seagull from './images/07-01-pc-01.webp';
import m6 from './Asset/byd-m6.webp';
import seal from './Asset/byd-seal.webp';
import denzad9 from './Asset/banner-DenzaD9.webp';
import sealion7 from './Asset/byd-sealion-7.webp';
import profileImg from './images/marketingjpg.jpg';

const Body = () => {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:600px)');

  const images = isMobile
    ? [mobile1, mobile2, mobile3]
    : [img1, img2, img3, img4];

  const handlePrev = () => {
    setCarouselIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCarouselIndex((prev) => (prev + 1) % images.length);
  };

  const explore = (path) => navigate(path);
  const brochures = [
    {
      name: 'BYD Atto 1',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYERATTO1FINALB.pdf`,
    },
    {
      name: 'BYD Dolphin',
      file: `${process.env.PUBLIC_URL}/files/Byd dolphin.pdf`,
    },
    {
      name: 'BYD Atto 3',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYER_ATTO_2025(AdvSTD-Superior).pdf`,
    },
    { name: 'BYD M6', file: `${process.env.PUBLIC_URL}/files/Byd m6.pdf` },
    {
      name: 'BYD Sealion 7',
      file: `${process.env.PUBLIC_URL}/files/FA_BROCHURE_SEALION7_12-compressed_1.pdf`,
    },
    {
      name: 'BYD Seal',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYER_SEAL_2025.pdf`,
    },
    {
      name: 'BYD Denza D9',
      file: `${process.env.PUBLIC_URL}/files/DOC-20250122-WA0016._20250122_102210_0000.pdf`,
    },
  ];
  const allCars = [
    {
      title: 'BYD - Dolphin',
      img: dolphin,
      desc: 'Rajai jalanan kota dengan BYD Dolphin, hatchback listrik yang mengutamakan efisiensi dan kepraktisan...',
      path: '/jelajahi-dolphin',
    },
    {
      title: 'BYD - 2024 ATTO 3',
      img: atto,
      desc: 'Temui masa depan kendaraan ramah lingkungan dengan BYD ATTO 3, SUV listrik dirancang untuk petualangan...',
      path: '/jelajahi-atto',
    },
    {
      title: 'BYD - Seal',
      img: seal,
      desc: 'BYD Seal mendefinisikan ulang ekspektasi Anda terhadap sedan listrik. Dengan garis desain yang elegan...',
      path: '/jelajahi-seal',
    },
    {
      title: 'BYD ATTO 1',
      img: seagull,
      desc: 'Kompak dan efisien untuk kebutuhan harian Anda.',
      path: '/jelajahi-atto1',
      isNew: true,
    },
    {
      title: 'BYD DENZA D9',
      img: denzad9,
      desc: 'MPV mewah dengan kenyamanan kelas atas.',
      path: '/jelajahi-denzad9',
    },
    {
      title: 'BYD SEALION 7',
      img: sealion7,
      desc: 'SUV listrik dengan teknologi futuristik.',
      path: '/jelajahi-sealion-7',
    },
    {
      title: 'BYD M6',
      img: m6,
      desc: 'Kenyamanan MPV yang cocok untuk keluarga Anda.',
      path: '/jelajahi-m6',
    },
  ];

  return (
    <>
      <Helmet>
        <title>BYD BSD Serpong | Dealer Resmi Mobil Listrik Tangerang</title>
        <meta
          name='description'
          content='Dealer resmi BYD BSD Serpong menyediakan mobil listrik seperti BYD Dolphin, Atto 3, Seal, dan Sealion 7. Hubungi Junius untuk test drive & brosur PDF.'
        />
        <meta
          name='keywords'
          content='BYD BSD Serpong, dealer BYD Tangerang, mobil listrik BYD, test drive, brosur BYD, harga BYD terbaru'
        />
        <meta name='robots' content='index, follow' />
        <meta name='author' content='Junius, Marketing BYD BSD' />
        <meta
          property='og:title'
          content='BYD BSD Serpong | Dealer Mobil Listrik Resmi'
        />
        <meta
          property='og:description'
          content='Temukan mobil listrik terbaik dari BYD bersama Junius di BSD Serpong. Tersedia brosur PDF dan informasi lengkap.'
        />
        <meta property='og:url' content='https://bydbsdserpong.com' />
        <meta property='og:type' content='website' />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: 'BYD BSD Serpong',
            '@id': 'https://bydbsdserpong.com',
            url: 'https://bydbsdserpong.com',
            telephone: '+6281286864825',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'BSD City, Lot 1 Kavling De Park',
              addressLocality: 'Tangerang Selatan',
              addressRegion: 'Banten',
              postalCode: '15331',
              addressCountry: 'ID',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: -6.3046,
              longitude: 106.6496,
            },
            openingHours: 'Mo-Su 09:00-17:00',
            sameAs: [
              'https://instagram.com/bydbsdserpong',
              'https://wa.me/6281286864825',
            ],
          })}
        </script>
      </Helmet>

      <Box>
        {/* Carousel Section */}
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '90vh',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: `${images.length * 100}vw`,
              transform: `translateX(-${carouselIndex * 100}vw)`,
              transition: 'transform 0.5s ease-in-out',
              height: '100%',
            }}
          >
            {images.map((img, index) => (
              <Box
                key={index}
                component='img'
                src={img}
                alt={`Slide ${index + 1}`}
                sx={{ width: '100vw', height: '100%', objectFit: 'cover' }}
              />
            ))}
          </Box>
          <IconButton
            onClick={handlePrev}
            sx={{
              position: 'absolute',
              top: '50%',
              left: 10,
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              position: 'absolute',
              top: '50%',
              right: 10,
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>

        {/* Auto Scroll Section */}
        <Box
          sx={{
            px: { xs: 2, sm: 4 },
            mt: 6,
            position: 'relative',
            overflowX: 'hidden',
          }}
        >
          {/* Manual Buttons */}
          <IconButton
            onClick={() => {
              const container = document.getElementById('scrollable-cars');
              container.scrollLeft -= 300;
            }}
            sx={{
              position: 'absolute',
              top: '50%',
              left: 0,
              zIndex: 1,
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.4)',
              color: '#fff',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              const container = document.getElementById('scrollable-cars');
              container.scrollLeft += 300;
            }}
            sx={{
              position: 'absolute',
              top: '50%',
              right: 0,
              zIndex: 1,
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.4)',
              color: '#fff',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

          {/* Scrollable container */}
          <Box
            id='scrollable-cars'
            sx={{
              display: 'flex',
              gap: 3,
              overflowX: 'auto',
              scrollBehavior: 'smooth',
              '&::-webkit-scrollbar': { display: 'none' }, // hide scrollbar
              animation: 'scrollLeft 60s linear infinite',
              '&:hover': { animationPlayState: 'paused' },
            }}
          >
            {[...allCars, ...allCars].map((car, idx) => (
              <Box
                key={idx}
                onClick={() => explore(car.path)}
                sx={{
                  flex: '0 0 auto',
                  width: 260,
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  boxShadow: 3,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': { transform: 'scale(1.05)', boxShadow: 6 },
                  position: 'relative',
                }}
              >
                {car.isNew && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      backgroundColor: '#e53935',
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 'bold',
                      px: 1,
                      py: 0.3,
                      borderRadius: '4px',
                      zIndex: 2,
                      animation: 'blinker 1s linear infinite',
                      boxShadow: '0 0 8px rgba(255,0,0,0.6)',
                    }}
                  >
                    🔥 HOT! NEW!
                  </Box>
                )}

                <Box
                  component='img'
                  src={car.img}
                  alt={car.title}
                  sx={{ width: '100%', height: 160, objectFit: 'cover' }}
                />
                <Box sx={{ p: 2 }}>
                  <Typography variant='subtitle1' fontWeight='bold'>
                    {car.title}
                  </Typography>
                  <Typography variant='body2' sx={{ mt: 1 }}>
                    {car.desc}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Personal Section */}
        <Box
          sx={{
            mt: 8,
            px: { xs: 2, md: 10 },
            py: 6,
            backgroundColor: '#f4f6f8',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: 4,
              borderRadius: 4,
              backgroundColor: '#fff',
              boxShadow: 3,
              p: 4,
            }}
          >
            <Box
              component='img'
              src={profileImg}
              alt='Junius Profile'
              sx={{ width: { xs: '100%', md: 300 }, borderRadius: 2 }}
            />
            <Box>
              <Typography variant='h5' fontWeight='bold' gutterBottom>
                Tentang Saya - Junius, Marketing Mobil Listrik BYD BSD
              </Typography>
              <Typography
                fontStyle='italic'
                color='text.secondary'
                gutterBottom
              >
                Selamat datang di BYD BSD Serpong — pusat mobil listrik ramah
                lingkungan. Saya Junius siap bantu Anda mendapatkan kendaraan
                BYD terbaik yang sesuai kebutuhan dan gaya hidup Anda.
              </Typography>
              <Typography paragraph>
                Sebagai spesialis marketing mobil listrik BYD di Tangerang, saya
                berkomitmen memberikan pengalaman terbaik bagi setiap calon
                pembeli. Saya akan membantu Anda memilih model BYD seperti Atto
                3, Dolphin, atau Sealion 7 yang tepat untuk kebutuhan mobilitas
                Anda.
              </Typography>
              <Typography paragraph fontWeight='bold'>
                Jangan ragu untuk hubungi saya langsung:
              </Typography>
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}
              >
                <WhatsAppIcon sx={{ color: '#25D366' }} />
                <a
                  href='https://wa.me/6281286864825'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#000', textDecoration: 'none' }}
                >
                  +62 812 8686 4825
                </a>
              </Box>
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}
              >
                <InstagramIcon sx={{ color: '#E1306C' }} />
                <a
                  href='https://instagram.com/bydbsdserpong'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#000', textDecoration: 'none' }}
                >
                  @bydbsdserpong
                </a>
              </Box>
              <Typography paragraph sx={{ mt: 2 }}>
                Bersama BYD, mari kita ciptakan masa depan berkendara yang lebih
                hijau, efisien, dan canggih di Indonesia.
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: 10, px: { xs: 2, sm: 4 }, pb: 8 }}>
          <Typography variant='h5' fontWeight='bold' sx={{ mb: 1 }}>
            Unduh Brosur Mobil Listrik BYD
          </Typography>
          <Typography variant='body2' sx={{ mb: 4 }}>
            Dapatkan spesifikasi lengkap, fitur unggulan, dan pilihan warna
            untuk setiap model mobil listrik BYD. Klik untuk mengunduh brosur
            resmi dalam format PDF.
          </Typography>
          <Grid
            container
            spacing={3}
            justifyContent='center'
            alignItems='stretch'
          >
            {brochures.map((bro, idx) => {
              const isHot = bro.name === 'BYD Atto 1';
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={idx}
                  sx={{ height: '100%' }}
                >
                  <Box
                    component='a'
                    href={bro.file}
                    target='_blank'
                    rel='noopener noreferrer'
                    data-skip-react-snap
                    sx={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <Card
                      sx={{
                        position: 'relative',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        textAlign: 'center',
                        p: 3,
                        borderRadius: 3,
                        transition: 'all 0.3s ease-in-out',
                        boxShadow: 1,
                        backgroundColor: isHot ? '#ffeceb' : 'inherit',
                        '&:hover': {
                          backgroundColor: '#e2574c',
                          color: '#fff',
                          transform: 'scale(1.03)',
                        },
                      }}
                    >
                      {isHot && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            backgroundColor: '#e53935',
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: 'bold',
                            px: 1,
                            py: 0.3,
                            borderRadius: '4px',
                            zIndex: 10,
                            animation: 'blinker 1s linear infinite',
                            boxShadow: '0 0 8px rgba(255,0,0,0.6)',
                            pointerEvents: 'none',
                          }}
                        >
                          🔥 HOT! NEW!
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: 'inline-block',
                          backgroundColor: '#ff725e',
                          borderRadius: 2,
                          p: 1,
                          mb: 2,
                        }}
                      >
                        <DescriptionIcon sx={{ fontSize: 40, color: '#fff' }} />
                      </Box>
                      <Typography variant='subtitle1' fontWeight='bold'>
                        Brosur {bro.name}
                      </Typography>
                      <Typography variant='body2' sx={{ mt: 1 }}>
                        Silahkan download brosur {bro.name} <br />
                        dengan klik gambar file diatas
                      </Typography>
                    </Card>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <style>{`
  @keyframes scrollLeft {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
    @keyframes blinker {
  0% { opacity: 1; }
  50% { opacity: 0.2; }
  100% { opacity: 1; }
}
`}</style>
      </Box>
    </>
  );
};

export default Body;
